import React, { useEffect, useState } from 'react'
import { useParams } from 'react-router-dom'
import Table from '@material-ui/core/Table'
import TableBody from '@material-ui/core/TableBody'
import TableContainer from '@material-ui/core/TableContainer'
import TableCell from '@material-ui/core/TableCell'
import TableSortLabel from '@material-ui/core/TableSortLabel'
import TableHead from '@material-ui/core/TableHead'
import TableRow from '@material-ui/core/TableRow'
import { makeStyles } from '@material-ui/styles'
import SearchBar from './search-bar'
import withSearch from './with-search'
import { LeadTableItem } from './lead-table-item'
import useIsMobile from 'lib/hooks/use-is-mobile'
import LeadsNewView from './leads-new-vew'
import { flags, useFeatureFlags } from 'lib/feature-flags'

export const useStyles = makeStyles(() => ({
  leadNameCell: {
    paddingLeft: '1.5rem',
  },
  visuallyHidden: {
    border: 0,
    clip: 'rect(0 0 0 0)',
    height: 1,
    margin: -1,
    overflow: 'hidden',
    padding: 0,
    position: 'absolute',
    top: 20,
    width: 1,
  },
}))

const LeadsTable = ({
  filteredItems,
  searchTerm,
  setSearchTerm,
  setUnviewedLeadCount,
  refetch,
  studentRefetch,
}) => {
  const classes = useStyles()
  const { leadId } = useParams()
  const isMobile = useIsMobile()
  const [sortOrder, setSortOrder] = useState('desc')
  const [isNewViewEnabled] = useFeatureFlags([flags.FLAG_NEW_LEADS_VIEW])

  useEffect(() => {
    const sessionSortOrder = window.sessionStorage.getItem('leadSortOrder')
    if (sessionSortOrder) {
      setSortOrder(sessionSortOrder)
    } else {
      sessionStorage.setItem('leadSortOrder', 'desc')
    }
  }, [])

  const toggleSort = () => {
    const newOrder = sortOrder === 'asc' ? 'desc' : 'asc'
    setSortOrder(newOrder)
    sessionStorage.setItem('leadSortOrder', newOrder)
  }

  const sortLeads = (items, order) => {
    if (order === 'desc') {
      return items.sort((a, b) => (a.createdAt < b.createdAt ? 1 : -1))
    } else if (order === 'asc') {
      return items.sort((a, b) => (a.createdAt > b.createdAt ? 1 : -1))
    }
  }

  if (isNewViewEnabled) {
    return (
      <LeadsNewView
        filteredItems={filteredItems}
        setUnviewedLeadCount={setUnviewedLeadCount}
        refetch={refetch}
        studentRefetch={studentRefetch}
      />
    )
  }

  return (
    <>
      {leadId}
      <TableContainer style={{ paddingBottom: isMobile ? '5rem' : '0' }}>
        <SearchBar
          searchTerm={searchTerm}
          setSearchTerm={setSearchTerm}
          label="Search Leads"
          data-testid="leads-list-search"
        />
        <Table>
          <TableHead>
            <TableRow justify="flex-start">
              <TableCell className={classes.leadNameCell}>Name</TableCell>
              {!isMobile ? <TableCell>Interest</TableCell> : null}
              {!isMobile ? (
                <TableCell sortDirection={sortOrder}>
                  <TableSortLabel
                    active={true}
                    direction={sortOrder}
                    onClick={toggleSort}
                  >
                    Created On
                    <span className={classes.visuallyHidden}>
                      {sortOrder === 'desc'
                        ? 'sorted descending'
                        : 'sorted ascending'}
                    </span>
                  </TableSortLabel>
                </TableCell>
              ) : null}
              {isMobile ? (
                <TableCell align="right">Actions</TableCell>
              ) : (
                <TableCell>Actions</TableCell>
              )}
            </TableRow>
          </TableHead>
          <TableBody>
            {sortLeads(filteredItems, sortOrder).map((lead, idx) => (
              <LeadTableItem
                lead={lead}
                key={`${lead.id}+${idx}`}
                setUnviewedLeadCount={setUnviewedLeadCount}
                refetch={refetch}
                studentRefetch={studentRefetch}
                sortOrder={sortOrder}
              />
            ))}
          </TableBody>
        </Table>
      </TableContainer>
    </>
  )
}

export default withSearch(LeadsTable)
